import { Subscription } from 'rxjs';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { HeaderService } from 'src/app/_services/header.service';
import { HeaderModel } from '../../_component/header/header.model';
import { ThisPlatform } from '../../_services/platform.service';
import { UserService } from '../../_services/user.service';
import { Community, CommunityType } from './../community/community.model';
import { CommunityService } from './../community/community.service';
import { IntegrationTripService } from './integration-trip.service';
import { TranslateService } from '@ngx-translate/core';
import { GroupedNews, IntegrationTripSegment } from './integration-trip.model';

@Component({
  selector: 'app-integration-trip',
  templateUrl: './integration-trip.page.html',
  styleUrls: ['./integration-trip.page.scss'],
  providers: [HeaderService],
})
export class IntegrationTripPage implements OnInit, OnDestroy {
  menu = [];
  currentMenuValue = null;
  temporaryMenu = [];
  temporaryMobileSegments = [];
  activeSegment = '';

  permissionAdmin = false;

  newsVisible: Community[];
  allNewsVisible = false;
  markingAsRead: boolean = false;
  newsVisibleInitCount = 5;
  newsAddVisible = 5;

  comType: number = CommunityType.IntegrationTrip;

  subs: Subscription[] = [];

  @ViewChild('searchBar')
  searchBar;

  headerInit: HeaderModel = {
    title: 'INTEGRATION.NAME',
    showOnTablet: true,
    segments: [
      {
        name: 'Info',
        value: String(IntegrationTripSegment.INFO),
      },
      {
        name: 'Aktualności',
        value: String(IntegrationTripSegment.NEWS),
        badge: this.communityServ.unreadCommunities.value?.length || null,
      },
      {
        name: 'Agenda wydarzenia',
        value: String(IntegrationTripSegment.AGENDA),
      }
    ],
    segmentsChangeFunc: (event) => {
      this.onSegmentChanged(Number(event.detail.value));
    },
    mobileSegments: [],
    userSettingsBreakpoint: 1200,
    mobileSegmentsChangeFunc: (event) => {
      this.onMobileSegmentChanged(Number(event.detail.value));
    },
    shouldHasMobileSegments: true,
  };

  CommunityType = CommunityType;

  groupedNews: GroupedNews = new GroupedNews();
  days: string[] = [];
  selectedDay: string = '';

  constructor(
    private integrationServ: IntegrationTripService,
    public communityServ: CommunityService,
    private userServ: UserService,
    public p: ThisPlatform,
    public platform: Platform,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private headerServ: HeaderService,
    private translate: TranslateService
  ) {}

  async ngOnInit() { }

  async ionViewWillEnter() { 
    this.subs.push(
      this.activatedRoute.queryParamMap.subscribe((p) => {
        const page = p.get('section');
        if (page && Number(page) <= this.headerInit.segments.length) {
          this.activeSegment = page;
        } else {
          this.activeSegment = '0';
          this.setQueryParam();
          this.headerServ.setHeaderInit(this.headerInit);
        }
        this.onSegmentChanged(Number(this.activeSegment));
      })
    );

    this.permissionAdmin = await this.userServ.hasRolesAsync([
      'community.admin',
    ]);

    await this.getTripInfo();

    this.menu = this.temporaryMenu;
    this.currentMenuValue = this.menu[0];

    this.subs.push(
      this.communityServ.unreadCommunities.subscribe((communities: Community[]) => {
        this.headerInit.segments[1].badge = communities.length || null;
        this.headerServ.setHeaderInit(this.headerInit);

        if (this.activeSegment === IntegrationTripSegment.NEWS.toString()) { 
          this.markAsRead();
        }
      })
    );
  }

  /**
   * Funkcja ustawiająca wartość parametru w linku
   */
  setQueryParam() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        section: this.activeSegment,
      },
    });
  }
  /**
   * Funkcja pobierająca dane do strony z serwisu
   */
  async getTripInfo() {
    this.temporaryMenu = await this.integrationServ.getTripInfo();
    this.temporaryMenu.forEach((e) => {
      this.headerInit.mobileSegments.push({
        value: e.id,
        name: e.name,
      });
    });
    this.temporaryMobileSegments = this.headerInit.mobileSegments;
    if (this.activeSegment !== '0') {
      this.headerInit.mobileSegments = [];
    }
  }

  /**
   *  Funkcja obsługująca zmianę segmentu
   * @param eventValue wartość segmentu uzyskana z eventu
   */
  onSegmentChanged(eventValue: number) {
    if (this.activeSegment !== eventValue + '') {
      this.activeSegment = eventValue + '';
      this.setQueryParam();
    }

    switch (eventValue) { 
      case IntegrationTripSegment.INFO: {
        this.headerInit.mobileSegments = this.temporaryMobileSegments;
        this.menu = this.temporaryMenu;
        break;
      }
      case IntegrationTripSegment.NEWS: {
        this.comType = CommunityType.IntegrationTrip;
        this.segmentChanged();
        this.markAsRead();
        break;
      }
      case IntegrationTripSegment.AGENDA: {
        this.comType = CommunityType.Agenda;
        this.segmentChanged();
        break;
      }
      default: { 
        break;
      }
    }

    this.headerInit.activeSegment = this.activeSegment;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  private segmentChanged() {
    this.headerInit.mobileSegments = [];
    this.menu = [];
    this.getNews();
  }

  /**
   * Funkcja pobierająca posty dotyczące Turcji 2021
   */
  getNews() {
    this.subs.push(
      this.communityServ
        .getComunitiesType(this.comType)
        .subscribe({
          next: (c: Community[]) => {
            this.communityServ.communities = c;
            this.communityServ.communitiesFilter = c;
            this.searchNews();
          },
          error: (err) => {
            console.error('Error loading communities:', err);
          }
        })
    );
  }
  /**
   * Funkcja obsługująca zmianę wartości drugich segmentów
   * @param eventValue wartość segmentu uzyskana z eventu
   */
  onMobileSegmentChanged(eventValue: number) {
    this.currentMenuValue = this.menu.find((e) => {
      if (e.id === eventValue) {
        return e;
      }
    });
  }

  /**
   * Funkcja wyszukująca posty
   */
  searchNews() {
    if (this.searchBar.ngModel && this.searchBar.ngModel.length > 0) {
      this.communityServ.communitiesFilter = this.communityServ.communities.filter(
        (item) => {
          return (item.title + ' ' + (item.description ? item.description : ''))
            .toUpperCase()
            .includes(this.searchBar.ngModel.toUpperCase());
        }
      );
    } else {
      this.communityServ.communitiesFilter = this.communityServ.communities;
    }
    const rows = this.communityServ.communitiesFilter;

    if (rows.length > this.newsVisibleInitCount) {
      this.newsVisible = rows.slice(0, this.newsVisibleInitCount);
      this.allNewsVisible = false;
    } else {
      this.newsVisible = rows;
      this.allNewsVisible = true;
    }

    if(this.comType === CommunityType.Agenda) {
      this.groupByDate()
    };
  }

  /**
   * Funkcja ładująca więcej postów
   */
  showMoreNews() {
    const from = this.newsVisible.length;
    let to = from + 5;
    const length = this.communityServ.communitiesFilter.length;

    if (to >= length) {
      to = length;
      this.allNewsVisible = true;
    }

    for (let i = from; i < to; i++) {
      const row = this.communityServ.communitiesFilter[i];
      this.newsVisible.push(row);
    }
  }
  /**
   * lazy loading
   * @param event $event
   */
  loadNews(event) {
    if(this.allNewsVisible) {
      event.target.complete();
      return;
    };

    window.setTimeout(() => {
      this.showMoreNews();
      event.target.complete();
    }, 500);
  }
  /**
   *  Funkcja odpowiadająca za przesuwanie się mobilnych segmentów
   * @param el wartość eventu z app-header
   */
  onIonChange(el: ElementRef) {
    if (el) {
      el.nativeElement.scrollIntoView();
    }
  }

  /**
   * Handles clicking on a day in the list
   * @param day day in 'YYYY-MM-DD' format
   */
  onDayChipClick(day: string) {
    this.selectedDay = day;
  }

  /**
   * Returns the day label in format 'Day Month'
   * @param dateStr date in 'YYYY-MM-DD' format
   * @returns day label
   */
  getDayLabel(dateStr: string): string {
    const dayKeys = ['DAY_MONDAY', 'DAY_TUESDAY', 'DAY_WEDNESDAY', 'DAY_THURSDAY', 'DAY_FRIDAY', 'DAY_SATURDAY', 'DAY_SUNDAY'];
    const date = new Date(dateStr);
    const dayKey = dayKeys[date.getDay()];
    const day = date.getDate();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${this.translate.instant(dayKey)} ${day}.${month}`;
  }

  /**
   * Groups news by date and sorts them
   * into a dictionary where keys are dates in 'YYYY-MM-DD' format
   * and values are arrays of news items for that date.
   * Also sorts the days in ascending order.
   */
  private groupByDate() { 
    this.groupedNews = new GroupedNews();
    this.days = [];

    this.newsVisible.forEach(item => {
      if (item.startTime) {
        const day = new Date(item.startTime).toISOString().slice(0, 10); // 'YYYY-MM-DD'
        if (!this.groupedNews[day]) {
          this.groupedNews[day] = [];
          this.days.push(day);
        }
        this.groupedNews[day].push(item);
      }
    });

    // Sort days ascending
    this.days.sort((a, b) => a.localeCompare(b));

    // Sort each group by startTime ascending
    for (const day of this.days) {
      this.groupedNews[day].sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());
    }

    // Default to first day
    this.selectedDay = this.days[0] || '';

  }

  private markAsRead() {  
    const ids = (this.communityServ.unreadCommunities.value || []).map(c => c.id);

    if (ids.length === 0) {
      return;
    }

    if(this.markingAsRead) {
      return;
    }

    this.markingAsRead = true;

    this.subs.push(
      this.communityServ.markAsRead(ids).subscribe({
        next: (res: Community[]) => {
          const readIds = res.map(c => c.id);
          this.communityServ.unreadCommunities.next(
            this.communityServ.unreadCommunities.value.filter(c => !readIds.includes(c.id))
          );
        },
        error: (err) => {
          this.markingAsRead = false;
        },
        complete: () => {
          this.markingAsRead = false;
        }
      })
    );
  }

  private onDestroy() { 
    for (const e of this.subs) {
      e.unsubscribe();
    }
  }

  ionViewWillLeave() { 
    this.onDestroy();
  }

  ngOnDestroy(): void {
    this.onDestroy();
  }
}

